<template>
  <div class="screen" id="loginScreen">
    <transition name="fade" mode="out-in" appear>
      <div class="main-login-container">
        <!-- <img class="fibercloud-logo" src="../assets/logos/weezie_fiber_compact_blue.svg"> -->
        <WeezieLogoSVG class="fibercloud-logo"></WeezieLogoSVG>
        <transition name="fadeLogin" mode="out-in" appear>
          <div class="loginContainer">
            <!-- <span id="loginTitle">{{ $t("Login") }}</span> -->

            <slot name="title" />

            <slot name="form" />

            <slot name="button" />

            <slot name="remember-me-reset-password" />

            <slot name="logoutButton" />
          </div>
        </transition>
      </div>
    </transition>
    <hub-footer :loading="false" :host="host" :version="version" />
  </div>
</template>

<script>
import HubFooter from '../components/Hub/HubFooter.vue';
import WeezieLogoSVG from "../assets/logos/weezie_fiber_compact_blue.svg"

export default {
  name: "Login",

  components: {
    HubFooter,
    WeezieLogoSVG,
  },

  data() {
    return {
      version: "Version 2.172",
    }
  },

  computed: {
    host() {
      let host = (new URL(window.location.href)).host;
      let hostName = host.split(".")[0];
      switch (hostName) {
        case "airband":
          return "Airband"
        case "tdf":
          return "TDF"
        case "rbbsh":
          return "RBBSH"
        case "united":
          return "United"
        case "gigaloch":
          return "Gigaloch"
        case "zetalink":
          return "Zetalink"
        default:
          return "Weezie"
      }
    }
  },
};
</script>

<style scoped>
.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 1s 0.5s;
}
.main-login-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 80%;
  justify-content: space-between;
}

.footer {
  width: 80% !important;
  bottom: 35px;
  position: absolute;
}

.footer >>> .socials-container {
  margin-right: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue